export var FaqUpdateMapper = function (datalist) {
    var result = { status: null, data: [] };
    if (datalist) {
        result.status = datalist.status;
        result.data = datalist.data;
    }
    return result;
};
